import React, { useContext } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled'
import CancelIcon from '@material-ui/icons/Cancel'
import FlexView from 'react-flexview/lib'
import { useParams } from 'react-router-dom'
import { PolicyManagementContextStore } from '../../../context/PolicyManagementContext'
import { awaitWithLoading } from '../../../services/utils'
import policymanagementApi from '../../../api/policymanagement.api'
import { ActiveInsuranceModel } from '../../../models/insurance-models/ActiveInsuranceModel'
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled'
import AssignmentIcon from '@material-ui/icons/Assignment'
import {
    EventEmitterService,
    EventKey,
} from '../../../services/EventEmitterService'
import { FormControlLabel, Tooltip } from '@material-ui/core'
import { PausePolicyPopup } from '../../PopUps/PausePolicyPopup'
import { SessionService } from '../../../services/SessionService'
import { GenerateEndorsementPopup } from '../GenerateEndorsementPopup'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { ElevatedCircle } from '../../Core/ElevatedCircle'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import NewFillButton from '../../Core/NewFillButton'
import Checkbox from '@material-ui/core/Checkbox';

interface PolicyActionsParams {
    insurance: ActiveInsuranceModel;
}

export const PolicyActions = ({ insurance }: PolicyActionsParams) => {
    const history = useHistory()
    const policyManagementContext = useContext(PolicyManagementContextStore)
    const [pausePopupOpen, setPausePopupOpen] = React.useState(false)
    const [genEndorsementPopupOpen, setGenEndorsementPopupOpen] =
        React.useState(false)
    let { path, url } = useRouteMatch()
    const insuranceId = insurance.insuranceId
    const closePausePolicyPopup = () => setPausePopupOpen(false)
    const openPausePolicyPopup = () => setPausePopupOpen(true)
    const closeGenEndorsementPopupOpen = () => setGenEndorsementPopupOpen(false)
    const openGenEndorsementPopupOpen = () => setGenEndorsementPopupOpen(true)
    const [openCancellationPopup, setOpenCancellationPopup] =
        React.useState(false)
    const [cancellationRefundAmount, setCancellationRefundAmount] =
        React.useState('0')
    const [isFullCancel, setIsFullCancel] = React.useState(false)
    const [needMinimumEarned, setNeedMinimumEarned] = React.useState(true)
    const [freeOfCharge, setFreeOfCharge] = React.useState(false)


    const pausePolicy = async () => {
        if (SessionService.isAdmin()) {
            openPausePolicyPopup()
        } else {
            let res = await awaitWithLoading(
                policyManagementContext.pausePolicy(insuranceId)
            )
            if (res.ok) {
                EventEmitterService.dispatch(EventKey.ShowSuccess, {
                    title: res.data.title,
                    body: res.data.message,
                })
            } else {
                EventEmitterService.dispatch(EventKey.ShowError, res)
            }
        }
    }

    const handleMinimumEarnedChange = async (event) => {
        setNeedMinimumEarned(event.target.checked)
        let res = await awaitWithLoading(
            policymanagementApi.calcCancellationProRataAmount(insuranceId, event.target.checked)
        )
        if (!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
        else{
            setCancellationRefundAmount(res.data.amount)
        }
    }

    const handleFreeOfCharge = async (event) => {
        setFreeOfCharge(event.target.checked)
        let res = await awaitWithLoading(
            policymanagementApi.calcFullCancellationAmount(insuranceId, event.target.checked)
        )
        if (!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
        else{
            setCancellationRefundAmount(res.data.amount)
        }
    }


    const calcFullCancellationAmount = async () => {
        setIsFullCancel(true)
        let res = await awaitWithLoading(
            policymanagementApi.calcFullCancellationAmount(insuranceId, freeOfCharge)
        )
        if (!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        } else {
            setCancellationRefundAmount(res.data.amount)
            setOpenCancellationPopup(true)
        }
    }

    const calcCancellationProRataAmount = async () => {
        setIsFullCancel(false)
        let res = await awaitWithLoading(
            policymanagementApi.calcCancellationProRataAmount(insuranceId, needMinimumEarned)
        )
        if (!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        } else {
            setCancellationRefundAmount(res.data.amount)
            setOpenCancellationPopup(true)
        }
    }

    const executeCancellation = async () => {
        let res
        if (isFullCancel) {
            res = await awaitWithLoading(
                policyManagementContext.cancelPolicy(insuranceId, true, freeOfCharge)
            )
        } else {
            res = await awaitWithLoading(
                policyManagementContext.cancelPolicy(insuranceId, false, needMinimumEarned)
            )
        }
        if (res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: 'Policy is cancelled',
            })
            setOpenCancellationPopup(false)
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    const handleClose = async () => {
        setIsFullCancel(false)
        setOpenCancellationPopup(false)
    }

    const unpausePolicy = async () => {
        let res = await awaitWithLoading(
            policyManagementContext.unpausePolicy(insuranceId)
        )
        if (res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: 'Policy Unpaused',
                body: 'Your policy is active again',
            })
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    return (
        <React.Fragment>
            {/* {SessionService.isAdmin() && (
                <FlexView vAlignContent={'center'} className="margin-top-6">
                    <AssignmentIcon className="blue" />
                    <div
                        onClick={openGenEndorsementPopupOpen}
                        className="text-small margin-left-6 blue underline clickable"
                    >
                        Generate Endorsement
                    </div>
                </FlexView>
            )} */}

            {SessionService.isAdmin() && (
                <>
                    <FlexView vAlignContent={'center'} className="margin-top-6">
                        <HighlightOffIcon className="blue" />
                        <div
                            onClick={calcCancellationProRataAmount}
                            className="text-small margin-left-6 blue underline clickable"
                        >
                            Cancel - Pro rata refund
                        </div>
                    </FlexView>
                    <FlexView vAlignContent={'center'} className="margin-top-6">
                        <HighlightOffIcon className="blue" />
                        <div
                            onClick={calcFullCancellationAmount}
                            className="text-small margin-left-6 blue underline clickable"
                        >
                            Full Cancel
                        </div>
                    </FlexView>
                </>
            )}

            {/* <GenerateEndorsementPopup insuranceId={insuranceId} open={genEndorsementPopupOpen} onCancel={closeGenEndorsementPopupOpen} /> */}

            <SkywatchDialog
                open={openCancellationPopup}
                circleHeader={
                    <ElevatedCircle>
                        <AccountCircleIcon className="blue" fontSize="large" />
                    </ElevatedCircle>
                }
                maxWidth={'sm'}
                closeDialog={handleClose}
            >
                <div className="blue bold text-title textcenter">
                    Refund will be: ${cancellationRefundAmount}
                </div>
                <NewFillButton onClick={executeCancellation}>
                    Confirm policy cancellation
                </NewFillButton>
                
                {isFullCancel ? (
                    <FormControlLabel
                    control={<Checkbox checked={freeOfCharge} onChange={handleFreeOfCharge} name="freeOfCharge" color="primary" />}
                    label="Cancel without refund"
                />
                ):(   
                    <FormControlLabel
                    control={<Checkbox checked={needMinimumEarned} onChange={handleMinimumEarnedChange} name="needMinimumEarned" color="primary" />}
                    label="Apply 50% earned premium"
                />
                )}

                <div
                    onClick={handleClose}
                    className="margin-bottom-basic text-body textcenter gray underline clickable"
                >
                    Close
                </div>
            </SkywatchDialog>
        </React.Fragment>
    )
}
